import { VercelProduct as Product } from 'lib/bigcommerce/types';

export function ProductSKU({ product }: { product: Product }) {
  return (
    <>
      <div>{product.sku}</div>
    </>
  );
}
